/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 public/coffee_barel.glb -o src/models/CoffeeBarrel.jsx --draco --transform --simplify --resolution=512 
Files: public/coffee_barel.glb [16.19MB] > /Users/radek/Documents/GIthub/CoffeeCoded/coffeecoded/src/models/coffee_barel-transformed.glb [1.2MB] (93%)
Author: Viktor.Zhuravlev (https://sketchfab.com/Viktor.Zhuravlev)
License: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
Source: https://sketchfab.com/3d-models/coffee-barel-3d38e93a409549c3824bcb9a374abf39
Title: Coffee barel
*/

import React from 'react'
import { useGLTF } from '@react-three/drei'
import modelUrl from '../assets/models/coffee_barel-transformed.glb'

export function Model(props) {
  const { nodes, materials } = useGLTF(modelUrl)
  return (
    <group {...props} dispose={null}>
      <mesh geometry={nodes.Cube010_Material001_0.geometry} material={materials['Material.001']} scale={0.01} />
    </group>
  )
}

useGLTF.preload(modelUrl)
